import { Register, Login, CIntermediate, VIntermediate, ResetPassword, NewPassword, CPostIntermediate } from '../views/Auth';
import { Feed, Chat, NewPost, Notification, Explore, Profile, PostDetails, Wallet, ViewerWallet, Settings, EditProfileCreator, EditProfileViewer, AddCard, ProfileViewer, ExploreUser, ExploreTrending, NewChat, UploadPost, NewProfile } from '../views/App'
import { SplashScreen } from '../components/common/SplashScreen';
import { About, Cookies, Copyright, Help, Privacy, Terms } from '../views/App/Legals';

const routes = [
    {
        path: '/home',
        component: Feed,
    },
    // {
    //     path: '/profile',
    //     component: Profile,
    // },
    {
        path: '/profile',
        component: NewProfile,
    },
    // {
    //     path: '/message',
    //     component: Chat,
    // },
    {
        path: '/message',
        component: NewChat,
    },
    {
        path: '/search',
        component: Explore,                   // this shall be uncommented 
    },
    {
        path: '/notification',
        component: Notification,
    },
    // {
    //     path: '/new-post',
    //     component: NewPost,
    // },
    {
        path: '/new-post',
        component: UploadPost,
    },
    {
        path: '/post',
        component: PostDetails,
    },
    {
        path: '/login',
        component: Login,
    },
    {
        path: '/creator-setup',
        component: CIntermediate,
    },
    {
        path: '/creator-tags',
        component: CPostIntermediate,
    },
    {
        path: '/viewer-setup',
        component: VIntermediate,
    },
    {
        path: '/register',
        component: Register,
    },
    {
        path: '/wallet-creator',
        component: Wallet,
    },
    {
        path: '/wallet',
        component: ViewerWallet,
    },
    {
        path: '/editprofile',
        component: EditProfileViewer,
    },
    {
        path: '/editprofile-creator',
        component: EditProfileCreator,
    },
    {
        path: '/add-card',
        component: AddCard,
    },
    {
        path: '/settings',
        component: Settings,
    },
    {
        path: '/new-password/:id',
        component: NewPassword,
    },
    {
        path: '/reset-password',
        component: ResetPassword,
    },
    {
        path: '/splash',
        component: SplashScreen,
    },
    {
        path: '/user/:username/posts',
        component: ExploreUser,
    },
    {
        path: '/:username/explore/posts',
        component: ExploreTrending,
    },
    {
        path: '/user',
        component: ProfileViewer,
    },
    {
        path: '/about',
        component: About,
    },
    {
        path: '/cookies',
        component: Cookies,
    },
    {
        path: '/help',
        component: Help,
    },
    {
        path: '/privacy',
        component: Privacy,
    },
    {
        path: '/terms',
        component: Terms,
    },
    {
        path: '/copyright',
        component: Copyright,
    },
];

export {
    routes
};